import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    height: 100%;
`;

export const Content = styled.div.attrs(()=>({
    className: "scrollbar"
}))`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    flex: 3;
    height: 100%;
    background-color: #222;
    position: relative;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    height: 30px;
    min-height: 30px;
    width: 100px;
    min-width: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }

    &.full {
        width: 100%;
    }
`;

export const NoMobile = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 10%;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    background-color: #222;
    color: #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 301;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 10%;
        right: 10%;
        height: 70px;
        background: url('/app/logo.png') no-repeat 50% 0%;
        background-size: contain;
    }

    @media (min-width: 800px) {
        display: none;
    }
`;

export const NoMobileImage = styled.img.attrs(({props})=>({
    src: '/app/nomobile.svg'
}))`
    width: 50%;
    height: auto;
`;

export const NoMobileContent = styled.div`
    margin: 30px 0;
`;